var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import createElement from '../logical-components/createElement';
// Global helpers
import svgs from './svgs';
import renderText from '../logical-components/renderText';
import Input from './input/field';
import Button from './input/button';
import './scss/rememberMe-actions.scss';
import constructName from '../logical-components/constructName';
// Message
var MessageComponent = function () {
    var container = createElement('div', [
        { type: 'class', value: '_msnlq-ae-c' },
    ]);
    container.innerHTML = "\n        <div class='_msnlq-ae-s-me'>\n            <h4> ".concat(renderText('actions.submit.success.title'), " </h4>\n            <p> ").concat(renderText('actions.submit.success.message'), " </p>\n        </div>\n        <div class='_msnlq-ae-e-me'>\n            <h4> ").concat(renderText('actions.submit.error.title'), " </h4>\n            <p> ").concat(renderText('actions.submit.error.message'), " </p>\n        </div>\n    ");
    return container;
};
var actions = [
    {
        icon: svgs.write,
        title: renderText('actions.write.title'),
        type: 'write',
    },
    {
        icon: svgs.flower,
        title: renderText('actions.flower.title'),
        type: 'flower',
    },
    {
        icon: svgs.candle,
        title: renderText('actions.candle.title'),
        type: 'candle',
    },
];
// Forms
var FormsComponent = function (_a) {
    var type = _a.type, handleChange = _a.handleChange, onSubmit = _a.onSubmit;
    var template = createElement('div');
    if (type === 'write') {
        template.appendChild(Input({
            name: 'message',
            label: renderText('actions.form.message.label'),
            placeholder: renderText('actions.form.message.placeholder'),
            onChange: function (e) {
                handleChange(type, 'message', e.target.value);
            },
            id: "".concat(type, "-form-message"),
            fieldType: 'textarea',
        }));
        template.appendChild(Input({
            name: 'private',
            label: renderText('actions.form.private.label'),
            fieldType: 'checkbox',
            placeholder: renderText('actions.form.private.placeholder'),
            onChange: function (e) {
                handleChange(type, 'private', e.target.checked);
            },
            id: "".concat(type, "-form-private"),
        }));
    }
    template.appendChild(Input({
        name: 'name',
        label: renderText('actions.form.name.label'),
        placeholder: renderText('actions.form.name.placeholder'),
        onChange: function (e) {
            handleChange(type, 'name', e.target.value);
        },
        id: "".concat(type, "-form-name"),
    }));
    template.appendChild(Input({
        name: 'email',
        label: renderText('actions.form.email.label'),
        labelInfo: renderText('actions.form.email.labelInfo'),
        placeholder: renderText('actions.form.email.placeholder'),
        onChange: function (e) {
            handleChange(type, 'email', e.target.value);
        },
        id: "".concat(type, "-form-email"),
    }));
    template.appendChild(Button({
        label: renderText('actions.form.button.label'),
        onClick: function () {
            onSubmit(type);
        },
    }));
    return template;
};
// Tabs
var TabsComponent = function (state, handleUpdate, onSubmit, handleClick) {
    var template = createElement('div');
    template.innerHTML = "\n        <div class='_msnlq-tabs'>\n        </div>\n        <div class='_msnlq-tabs-contentblocks'>\n        </div>\n    ";
    // generate Tabs
    var tabWrapper = template.querySelector('._msnlq-tabs');
    var tabContentWrapper = template.querySelector('._msnlq-tabs-contentblocks');
    actions.forEach(function (action) {
        // Build tab
        var tab = createElement('div', [
            { type: 'class', value: "_msnlq-tab _msnlq-tab-".concat(action.type) },
        ]);
        tab.innerHTML = "\n            <span class='_msnlq-icons'> ".concat(action.icon, " </span>\n            <span class='_msnlq-tab-text'> ").concat(action.title, " </span>\n        ");
        tab.addEventListener('click', function () {
            handleClick(action.type);
        });
        tabWrapper.appendChild(tab);
        // Build content
        var tabContent = createElement('div', [
            {
                type: 'class',
                value: "_msnlq-tab-content _msnlq-tab-content-".concat(action.type),
            },
        ]);
        tabContent.appendChild(FormsComponent({
            type: action.type,
            onSubmit: onSubmit,
            handleChange: handleUpdate,
        }));
        tabContentWrapper.appendChild(tabContent);
    });
    return template;
};
// Visual component
var rememberMeActions = function (config, section, onSubmit, onClose, reply) {
    var _a;
    var wrapper = createElement('div');
    wrapper.className = '_msnlq-act-wrapper _mslq-ct-wrapper-cl';
    wrapper.innerHTML = "<div class='_msnlq-act-content'>\n        <fieldset>\n            <div class='_msnlq-act-in-content'>\n    \n            </div>\n        </fieldset>\n        <div class='_msnlq-act-close'> ".concat(svgs.close, " </div>\n    </div>\n    ");
    if (reply) {
        wrapper.classList.add('_msnlq-limited-actions');
    }
    wrapper.querySelector('._msnlq-act-close').addEventListener('click', function () {
        onClose(wrapper);
    });
    var actionsWrapper = wrapper.querySelector('._msnlq-act-in-content');
    if ((_a = section === null || section === void 0 ? void 0 : section.options) === null || _a === void 0 ? void 0 : _a.hideActions) {
        return actionsWrapper;
    }
    var activeState = 'write';
    // Actions data
    var state = {
        write: {
            message: '',
            name: '',
            private: '',
            email: '',
            videoUrl: '',
            image: '',
        },
        candle: {
            name: '',
            email: '',
        },
        flower: {
            name: '',
            email: '',
        },
    };
    var handleUpdate = function (type, key, value) {
        var _a, _b;
        state = __assign(__assign({}, state), (_a = {}, _a[type] = __assign(__assign({}, state[type]), (_b = {}, _b[key] = value, _b)), _a));
    };
    var handleErrors = function (message, tab) {
        var hasErrors = message !== false;
        wrapper.classList.toggle('_msnlq-error-true', hasErrors);
        wrapper.classList.toggle('_msnlq-posted-true', !hasErrors);
        if (!hasErrors) {
            return;
        }
        var errors = message.errors;
        var inputs = wrapper.querySelectorAll('input, textarea');
        Array.prototype.slice.call(inputs).forEach(function (input) {
            var id = input.getAttribute('id');
            var name = input.getAttribute('name');
            var inCurrentTab = id.startsWith("field-".concat(tab, "-form-"));
            var hasError = errors.hasOwnProperty(name);
            // turn error on by wrapper
            var inputWrapper = input.closest('._msng-input-wrapper');
            inputWrapper.classList.toggle('_msng-has_error', hasError && inCurrentTab);
            var error = hasError ? errors[name][0] : null;
            inputWrapper.querySelector('._mnslq-error').innerHTML = error;
        });
    };
    var handleSubmit = function () {
        setLoadingState(true);
        onSubmit(__assign(__assign({}, state[activeState]), { type: activeState }))
            .then(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                handleErrors(false);
                return [2 /*return*/];
            });
        }); })
            .catch(function (response) {
            handleErrors(response, activeState);
        })
            .finally(function () {
            setLoadingState(false);
            // submitButton.classList.remove('_mnslq-button-loading');
        });
    };
    var setLoadingState = function (state) {
        var submitButton = wrapper.querySelector('fieldset');
        if (state) {
            submitButton.setAttribute('disabled', 'disabled');
        }
        else {
            submitButton.removeAttribute('disabled');
        }
    };
    var processActiveTabs = function () {
        // Correct / reset tabs
        var activeTab = actionsWrapper.querySelector('.msnlq-active-tab');
        if (activeTab) {
            activeTab.classList.remove('msnlq-active-tab');
        }
        var activeContent = actionsWrapper.querySelector('.msnlq-active-content');
        if (activeContent) {
            activeContent.classList.remove('msnlq-active-content');
        }
        // Set correct tabs
        actionsWrapper
            .querySelector("._msnlq-tab-".concat(activeState))
            .classList.add('msnlq-active-tab');
        actionsWrapper
            .querySelector("._msnlq-tab-content-".concat(activeState))
            .classList.add('msnlq-active-content');
    };
    var handleClick = function (type) {
        // Update state
        activeState = type;
        processActiveTabs();
    };
    // Render
    actionsWrapper.innerHTML = "<h3> ".concat(renderText('rememberMe.actions'), " </h3>");
    actionsWrapper.appendChild(TabsComponent(state, handleUpdate, handleSubmit, handleClick));
    actionsWrapper.appendChild(MessageComponent());
    processActiveTabs();
    return wrapper;
};
var rememberMeActionWrapper = function (config, section, onSubmit, reply, item) {
    var overlayOpen = false;
    var actionsWrapper = createElement('div');
    actionsWrapper.className = '_msnlq-act-container';
    actionsWrapper.innerHTML = "<div class='_mnslq-ac'>\n        <div>\n            <div class='_mnslq-ac-icon'> ".concat(svgs.write, " </div>\n            <div class='_mnslq-ac-title'> \n                ").concat(reply
        ? renderText('rememberMe.reply', constructName(item))
        : renderText('rememberMe.condolence'), "\n                <span class='_msnlq-ac-arrow'> ").concat(svgs.arrow, " </span>\n            </div>\n            \n        </div>\n    </div>");
    var toggleOverlay = function (wrapper) {
        overlayOpen = !overlayOpen;
        var ele = actionsWrapper.querySelector('._msnlq-act-wrapper');
        if (overlayOpen) {
            ele.classList.remove('_mslq-ct-wrapper-cl');
        }
        else {
            ele.classList.add('_mslq-ct-wrapper-cl');
            // RESET form
            wrapper.classList.remove('_msnlq-posted-true');
            wrapper.querySelectorAll('._msng-input-wrapper input, ._msng-input-wrapper textarea').forEach(function (el) {
                el.value = '';
            });
            // remove errors
            wrapper.classList.remove('_msnlq-error-true');
            wrapper.querySelectorAll('._msng-input-wrapper').forEach(function (el) {
                el.classList.remove('_msng-has_error');
            });
        }
    };
    actionsWrapper.appendChild(createElement('div', [{ type: 'class', value: '_msnlq-action-embed' }]));
    actionsWrapper
        .querySelector('._msnlq-action-embed')
        .appendChild(rememberMeActions(config, section, onSubmit, toggleOverlay, reply));
    actionsWrapper.querySelector('._mnslq-ac').addEventListener('click', function () {
        toggleOverlay(actionsWrapper);
    });
    return actionsWrapper;
};
export default rememberMeActionWrapper;
